export default "__VITE_ASSET__DyNNuqYs__"